


































import Vue from 'vue'
export default Vue.extend({
  props: {
    value: { type: Boolean, default: false },
    orderId: { type: String, default: ""}
  },
  data() {
    return {
      cancellationReasonId: null,
      error: false,
    }
  },
  methods: {
    resetClose() {
      this.$emit('hide-dialog', true)
      this.cancellationReasonId = null
      this.error = false
    },
    getCancellationReason() {
      if (this.cancellationReasonId === 1)
        return "Doppelter Auftrag"
      if (this.cancellationReasonId === 2)
        return "Versehentlicher Auftrag"
      return "Keine Angabe"
      
    },
    cancelOrder() {
      if (this.cancellationReasonId == null) {
        this.error = true;
        return;
      }
      const req = {
        orderId: this.orderId,
        cancellationReasonId: this.cancellationReasonId,
      };
      this.$store
        .dispatch("cancelOrder", req)
        .then(() => {
          this.$toast("Der Auftrag wurde wunschgemäß storniert.", {
            timeout: 5000,
          });
          if (this.$cookies.isAccepted()){
            (this as any).$gtag.event('order-cancel', {
              'event_category': 'order',
              'event_label': this.getCancellationReason(),
            })
          }
        })
        .catch((e) => {
          this.$toast.error(e.response.data.error.message);
        });
      this.resetClose()
      this.$emit("refresh-history");

    },

  }
})
